// Utilidades para RUT chileno (limpieza, validación de dígito verificador y formato).

// Quita puntos, guión y espacios; deja el dígito verificador en mayúscula.
export const cleanRut = (rut) => {
    if (!rut) return '';
    return String(rut).replace(/[.\-\s]/g, '').toUpperCase();
};

// Valida el dígito verificador (módulo 11).
export const validateRut = (rut) => {
    const clean = cleanRut(rut);
    if (clean.length < 2) return false;

    const body = clean.slice(0, -1);
    const dv = clean.slice(-1);

    if (!/^\d+$/.test(body)) return false;

    let sum = 0;
    let multiplier = 2;
    for (let i = body.length - 1; i >= 0; i--) {
        sum += parseInt(body[i], 10) * multiplier;
        multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const remainder = 11 - (sum % 11);
    const expectedDv = remainder === 11 ? '0' : remainder === 10 ? 'K' : String(remainder);

    return dv === expectedDv;
};

// Valida SOLO el formato: cuerpo numérico + un dígito verificador (0-9 o K).
// No verifica el dígito verificador (módulo 11), por lo que 11.111.111-2 pasa.
export const hasValidRutFormat = (rut) => {
    const clean = cleanRut(rut);
    if (clean.length < 2) return false;

    const body = clean.slice(0, -1);
    const dv = clean.slice(-1);

    return /^\d+$/.test(body) && /^[0-9K]$/.test(dv);
};

// Formatea a 12.345.678-9. Si es inválido, devuelve el input original.
export const formatRut = (rut) => {
    const clean = cleanRut(rut);
    if (clean.length < 2) return rut || '';

    const body = clean.slice(0, -1);
    const dv = clean.slice(-1);
    const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `${withDots}-${dv}`;
};

// Como se muestra el documento de quien recibio una entrega (`receipt.tin`).
//
// La app movil guarda ahi un RUT ("12.345.678-9") o, si quien recibe no tiene RUT, un
// pasaporte con el prefijo "PASAPORTE " ("PASAPORTE AB123456"). Formatear todo como RUT
// dejaba el pasaporte deformado ("AB12345-6"), asi que solo se formatea lo que tiene forma de
// RUT; el resto se muestra tal cual.
export const formatReceiptTin = (tin) => {
    if (!tin) return '';
    const value = String(tin).trim();
    if (/^PASAPORTE\s/i.test(value)) return value.replace(/^pasaporte/i, 'Pasaporte');
    return hasValidRutFormat(value) ? formatRut(value) : value;
};
